import AWSS3Provider from './AWSS3Provider';

export { AWSS3Provider };
